// extracted by mini-css-extract-plugin
export default {"name":"Verify_name__XTcyF","centered":"Verify_centered__KdTi-","instruction":"Verify_instruction__r2nCv"};